import { IconProps } from './icons-props';

function LockIcon({ className, width = 14, height = 16 }: IconProps) {
    return (
        <>
            <svg
                className={className}
                width={width}
                height={height}
                viewBox='0 0 14 16'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    d='M11.6668 5.616V4.66667C11.6668 3.42899 11.1752 2.242 10.3 1.36684C9.42482 0.491665 8.23784 0 7.00016 0C5.76249 0 4.5755 0.491665 3.70033 1.36684C2.82516 2.242 2.3335 3.42899 2.3335 4.66667V5.616C1.73974 5.87514 1.23436 6.30168 0.879162 6.84347C0.523966 7.38527 0.334348 8.01882 0.333496 8.66667V12.6667C0.334555 13.5504 0.686084 14.3976 1.31098 15.0225C1.93587 15.6474 2.7831 15.9989 3.66683 16H10.3335C11.2172 15.9989 12.0645 15.6474 12.6893 15.0225C13.3142 14.3976 13.6658 13.5504 13.6668 12.6667V8.66667C13.666 8.01882 13.4764 7.38527 13.1212 6.84347C12.766 6.30168 12.2606 5.87514 11.6668 5.616ZM3.66683 4.66667C3.66683 3.78261 4.01802 2.93477 4.64314 2.30964C5.26826 1.68452 6.11611 1.33333 7.00016 1.33333C7.88422 1.33333 8.73206 1.68452 9.35718 2.30964C9.98231 2.93477 10.3335 3.78261 10.3335 4.66667V5.33333H3.66683V4.66667ZM12.3335 12.6667C12.3335 13.1971 12.1228 13.7058 11.7477 14.0809C11.3726 14.456 10.8639 14.6667 10.3335 14.6667H3.66683C3.1364 14.6667 2.62769 14.456 2.25262 14.0809C1.87754 13.7058 1.66683 13.1971 1.66683 12.6667V8.66667C1.66683 8.13623 1.87754 7.62753 2.25262 7.25245C2.62769 6.87738 3.1364 6.66667 3.66683 6.66667H10.3335C10.8639 6.66667 11.3726 6.87738 11.7477 7.25245C12.1228 7.62753 12.3335 8.13623 12.3335 8.66667V12.6667Z'
                    fill='currentColor'
                />
            </svg>
        </>
    );
}

export default LockIcon;

